export default {
	home: {
		name: "add goods"
	},
	page_out_trade_no: "Merchant Order Number",
	submit_modeling_model_file_not_ready:
		"The model file is not ready yet. Please try again later or contact support."
};
